import { render, staticRenderFns } from "./MemoryCircleTemplateManage.vue?vue&type=template&id=333dafb6&"
import script from "./MemoryCircleTemplateManage.vue?vue&type=script&lang=js&"
export * from "./MemoryCircleTemplateManage.vue?vue&type=script&lang=js&"
import style0 from "./MemoryCircleTemplateManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports